import { ContentSaveAlertOutlineIcon } from './ContentSaveAlertOutlineIcon';

/**
 * author: Michael Richins
 * id 21B9916D-3D1A-43AF-91B2-56A4D5C493C2
 * name content-save-alert-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const FloppyDiscAlertOutlineIcon = ContentSaveAlertOutlineIcon;
export default FloppyDiscAlertOutlineIcon